export function requireWechatCodeUrl(value) {
  if (typeof value !== 'string' || !value.trim().startsWith('weixin://wxpay/bizpayurl?')) {
    throw new Error('微信支付码获取失败，请刷新重试或联系客服')
  }
  return value.trim()
}
